import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { UserCredentials } from '@ais-ui/auth';

interface AuthProviderContextState {
  credentials: UserCredentials;
}

const AuthContext = createContext<AuthProviderContextState | undefined>(
  undefined,
);

export interface AuthProviderProps {
  children: ReactNode;
}

export const SimpleAuthProvider = ({ children }: AuthProviderProps) => {
  const [credentials, setCredentials] = useState<UserCredentials>({
    username: 'nbs',
    password: 'nbs!password123NBS',
  });

  const value = useMemo(
    () => ({
      credentials,
    }),
    [credentials],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useSimpleAuth = () => {
  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error('useSimpleAuth must be used within an SimpleAuthProvider');
  }

  return authContext;
};
